import { components } from './components';
import { palette as darkPalette } from './palette/dark';
import { typography } from './typography';
import { ThemeOptions } from '@mui/material';

export const darkThemeOptions: ThemeOptions = {
  typography,
  palette: darkPalette,
  components,
};
